import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';

import { httpExtensionService } from './httpextension.service';
@Injectable()
export class UserService {

    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService) { }

    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }

    getTimeZone(){
        let body = {};
        let headers = new Headers();
        return this.http.get(this.config.getTimeZone, {
            headers: headers
        })
    }

    userLogin(user: any) {
        let body = 'username=' + user.username + '&password=' + user.password;
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.adminLogin, body, {
            headers: headers
        })

    }

    userLogout() {
        this.sessionService.unsubscribeFromForceRefresh();
        let user_token: string = this.sessionService.getToken();
        let body = {};
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        //headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.adminLogout, body, {
            headers: headers
        })
    }

    private handleError(error: any) {
        return Observable.throw(error.json());
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/user.service.ts